/* eslint-disable no-console */
import React, { useContext, useEffect, useState, useMemo } from 'react';
import PropTypes from 'prop-types';

import { createSearchParams, useLocation, useSearchParams, useParams, useNavigate } from 'react-router-dom';

import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import DevicesIcon from '@mui/icons-material/Devices';
import KeyIcon from '@mui/icons-material/Key';
import SettingsInputHdmiOutlinedIcon from '@mui/icons-material/SettingsInputHdmiOutlined';
import Tooltip from '@mui/material/Tooltip';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import LogoutIcon from '@mui/icons-material/Logout';
import getI18nService from '../../i18n/i18n';
import { Context } from '../../store/Store';
import userService from '../../api/UserService';
import Logo from '../includes/Logo';
import Footer from '../includes/Footer';
import Wireless from './Wireless';
import Wired from './Wired';
import { typeAll, typeWired, typeWireless, getAllDevices, logoutUser } from './Utils';
import UserDevices from './UserDevices';

const Item = styled(Paper)(({ theme }) => ({
  // backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(0.5),
  textAlign: 'center',
  color: theme.palette.text.secondary,
  borderRadius: '50%',
  // width: 75,
  // height: 75,
  border: `1px solid ${theme.palette.grey['500']}`,
  display: 'flex',
}));

const i18n = getI18nService();

const Register = props => {
  const [state, dispatch] = useContext(Context);
  const theme = useTheme();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  let location = useLocation();
  const [typeQuery, setTypeQuery] = useState(searchParams.get('type'));
  const { tenantToken, sessionId } = useParams();
  const [allDevices, setAllDevices] = useState([]);
  const { api } = state;
  const userInfo = api[userService.GetUserInfo.name];

  const { ui } = state;
  const { customization } = ui;
  const { allowWired, allowWireless } = ui;

  useEffect(() => {
    const newType = searchParams.get('type');
    if (newType !== typeQuery) {
      setTypeQuery(newType);
    }
  }, [location]);

  const fetchAllDevices = async () => {
    const result = await getAllDevices(userInfo);
    if (result) {
      setAllDevices(result);
    }
  };

  useEffect(() => {
    if (userInfo) {
      fetchAllDevices();
    }
  }, [userInfo]);

  console.log(typeQuery);
  // let query = useQuery();
  const getQuery = () => {
    console.log(searchParams.get('type'));
    setTypeQuery(searchParams.get('type'));
  };
  const setQuery = (event, tab) => {
    setTypeQuery(tab);
    setSearchParams(createSearchParams({ type: tab }));
  };

  const logout = async event => {
    const resp = await logoutUser(userInfo, state, dispatch);
    if (resp) {
      const type = 'logged_out';
      navigate({
        pathname: '/self-register/session/register/startover',
        search: createSearchParams({
          type,
        }).toString(),
      });
    }
  };

  return (
    <>
      {customization && (
        <Box
          id="test_self_register_register"
          sx={{
            minWidth: 1024,
            width: '90%',
            height: '90%',
            borderRadius: 4,
            mx: 'auto',
            mt: 8,
            mb: 4,
            backgroundColor: 'rgba(0, 0, 0, 0.8)',
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            spacing={2}
            sx={{ p: theme.spacing(5, 5, 1, 5) }}
          >
            <Stack>
              {customization?.logo?.data && (
                <Logo width={50} height={30} data={customization.logo.data} css={customization.logo.css} />
              )}
              {!customization?.logo?.data && (
                <Typography variant="h4">
                  {customization?.tenantName ? customization.tenantName : 'Nile Secure'}
                </Typography>
              )}
              {/* <Typography align="center" variant="body2">{`${i18n.t('Vocabulary.welcome')} ${
                  userInfo ? userInfo.user_name : ''
                }!`}</Typography> */}
            </Stack>
            <Button variant="outlined" onClick={logout} id="test_self_register_logoutBtn" endIcon={<LogoutIcon />}>
              {i18n.t('Vocabulary.logout')}
            </Button>
          </Stack>
          <Paper sx={{ textAlign: 'center', m: 3, p: 2, overflow: 'auto' }}>
            <Tabs value={typeQuery} onChange={setQuery} aria-label="Device types" sx={{ height: 65 }}>
              <Tab
                icon={<KeyIcon />}
                value={typeWireless}
                iconPosition="start"
                label="Manage WiFi Key"
                sx={{ textTransform: 'inherit' }}
              />
              <Tab
                icon={<SettingsInputHdmiOutlinedIcon />}
                value={typeWired}
                iconPosition="start"
                label="Manage Wired Devices"
                sx={{ textTransform: 'inherit' }}
              />
              <Tab
                icon={<DevicesIcon />}
                value={typeAll}
                iconPosition="start"
                label="Manage All Devices"
                sx={{ textTransform: 'inherit' }}
              />
            </Tabs>
            <Grid container spacing={1}>
              <Grid xs={12}>
                {allowWireless && typeQuery === typeWireless && userInfo && (
                  <Wireless userInfo={userInfo} deviceList={allDevices} onAddRemoveDevice={fetchAllDevices} />
                )}
                {allowWired && typeQuery === typeWired && userInfo && (
                  <Wired userInfo={userInfo} deviceList={allDevices} onAddRemoveDevice={fetchAllDevices} />
                )}
                {typeQuery === typeAll && userInfo && (
                  <UserDevices userInfo={userInfo} deviceList={allDevices} onDeviceDelete={fetchAllDevices} />
                )}
              </Grid>
            </Grid>
          </Paper>
          {userInfo && (
            <Typography variant="subtitle1" align="center">
              {i18n.t('SelfRegister.limits', {
                keys: userInfo.limits.credentials,
                devices: userInfo.limits.devices,
              })}
            </Typography>
          )}
          <Footer />
        </Box>
      )}
    </>
  );
};

Register.propTypes = {
  // userInfo: PropTypes.object.isRequired,
};

export default Register;
